import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getLatestMessage } from "redux-flash";
import { Field, reduxForm } from "redux-form";
import { TextField } from "redux-form-material-ui";
import Button from "material-ui/Button";
import { CircularProgress } from "material-ui/Progress";

import CenteredForm from "../utils/form/CenteredForm";
import { required, email } from "../utils/form/formValidation";

import { passwordRecoveryRequest } from "./actions";

import styles from "./PasswordRecovery.scss";

class PasswordRecovery extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    passwordRecoveryRequest: PropTypes.func.isRequired,
    "password-recovery": PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
    }).isRequired,
    snackbarMessage: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  submit = (values) => {
    this.props.passwordRecoveryRequest(values);
  };

  render() {
    const {
      handleSubmit,
      "password-recovery": { requesting, successful },
      snackbarMessage,
    } = this.props;

    return (
      <div className={styles.container}>
        <a href="/patient-playlists">
          <img
            src="assets/img/DD-logo-long-noir.png"
            className={styles.title_DD}
          />
        </a>
        <CenteredForm
          title="Mot de passe oublié"
          handleOnSubmit={handleSubmit(this.submit)}
          snackbarMessage={snackbarMessage}
        >
          <div className="mb3">
            <Field
              name="email"
              label="Email"
              component={TextField}
              validate={[required, email]}
              fullWidth
            />
          </div>
          <Button
            type={requesting || successful ? "" : "submit"}
            variant="raised"
            color="secondary"
            fullWidth
          >
            {!requesting && "Envoyer"}
            {requesting && <CircularProgress className={styles.requesting} />}
          </Button>
        </CenteredForm>
        {/* <style dangerouslySetInnerHTML={{
          __html: `
            body{
                background-image: radial-gradient(closest-side, rgba(62, 154, 215, 0.76), rgb(46, 143, 227));
            }`}} /> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  "password-recovery": state["password-recovery"],
  snackbarMessage: getLatestMessage(state) || {},
});

// eslint-disable-next-line max-len
const ConnectedPasswordRecovery = connect(mapStateToProps, {
  passwordRecoveryRequest,
})(PasswordRecovery);

export default reduxForm({
  form: "password-recovery",
})(ConnectedPasswordRecovery);



// WEBPACK FOOTER //
// ./src/pages/password-recovery/PasswordRecovery.jsx